"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cyptoUtils_1 = require("../../../cyptoUtils");
var SSOStoreDefault = /** @class */ (function () {
    function SSOStoreDefault() {
    }
    Object.defineProperty(SSOStoreDefault.prototype, "accountId", {
        get: function () { return null; },
        set: function (value) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SSOStoreDefault.prototype, "keyPair", {
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SSOStoreDefault.prototype, "privKey", {
        get: function () { return null; },
        set: function (value) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SSOStoreDefault.prototype, "tmpPrivKey", {
        get: function () {
            var privKeyString = localStorage.getItem('__ssoTmpPrivKey');
            if (!privKeyString) {
                return null;
            }
            return Buffer.from(privKeyString, 'hex');
        },
        set: function (value) {
            localStorage.setItem('__ssoTmpPrivKey', value.toString('hex'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SSOStoreDefault.prototype, "tmpKeyPair", {
        get: function () {
            var privKeyString = localStorage.getItem('__ssoTmpPrivKey');
            if (!privKeyString) {
                return null;
            }
            return new cyptoUtils_1.KeyPair(privKeyString);
        },
        enumerable: true,
        configurable: true
    });
    SSOStoreDefault.prototype.clearTmp = function () {
        localStorage.removeItem('__ssoTmpPrivKey');
    };
    SSOStoreDefault.prototype.clear = function () {
        this.clearTmp();
    };
    return SSOStoreDefault;
}());
exports.default = SSOStoreDefault;
//# sourceMappingURL=sso-store-default.js.map